<div *ngIf="uuid && data" [ngClass]="{'plateAIncorrect':data.plateAIncorrect,'plateBIncorrect':data.plateBIncorrect,'plateCIncorrect':data.plateCIncorrect,'driverNameIncorrect':data.driverNameIncorrect,'driverPhoneIncorrect':data.driverPhoneIncorrect,'driverLegalIdentificationIncorrect':data.driverLegalIdentificationIncorrect,
    'carrierNameIncorrect':data.carrierNameIncorrect,'carrierLegalIdentificationIncorrect':data.carrierLegalIdentificationIncorrect,'carrierAddressIncorrect':data.carrierAddressIncorrect}">
    <div *ngIf="!requereixBooking()" class="titol">
        <div class="inline" *ngIf="!editMode">
            <div *ngIf="data.showAskCarrierName" class="box carrierName">
                <div class="toplabel">
                    {{'ROUTEPAGE.ITEM.EDIT.CARRIERNAME' | translate}}
                </div><span class="invisible" *ngIf="!data.carrierName">{{'SHARED.EXTERNAL.NOCARRIERNAME' |
                    translate}}</span>
                {{data.carrierName}}
            </div>
            <div *ngIf="data.showAskCarrierLegalIdentification" class="box carrierLegalIdentification">
                <div class="toplabel">
                    {{'ROUTEPAGE.ITEM.EDIT.CARRIERLEGALIDENTIFICATION' | translate}}
                </div><span class="invisible"
                    *ngIf="!data.carrierLegalIdentification">{{'SHARED.EXTERNAL.NOCARRIERLEGALIDENTIFICATION' |
                    translate}}</span>
                {{data.carrierLegalIdentification}}
            </div>
            <div *ngIf="data.showAskCarrierAddress" class="box carrierAddress">
                <div class="toplabel">
                    {{'ROUTEPAGE.ITEM.EDIT.CARRIERADDRESS' | translate}}
                </div><span class="invisible" *ngIf="!data.carrierAddress">{{'SHARED.EXTERNAL.NOCARRIERADDRESS' |
                    translate}}</span>
                {{data.carrierAddress}}
            </div>


            <div class="box driverName">
                <div class="toplabel">{{'ROUTEPAGE.ITEM.EDIT.DRIVERNAME' | translate}}</div><span
                    class="invisible" *ngIf="!data.driverName">{{'SHARED.EXTERNAL.NODRIVERNAME' |
                    translate}}</span>
                {{data.driverName}}
            </div>
            <div class="box transportationRegistrationCode">
                <div class="toplabel">{{ 'ROUTEPAGE.ITEM.EDIT.TRANSPORTATIONREGISTRATIONCODE' | translate}}
                </div><span class="invisible"
                    *ngIf="!data.transportationRegistrationCode">{{'SHARED.EXTERNAL.NOTRANSPORTATIONREGISTRATIONCODE'
                    | translate}}</span> {{data.transportationRegistrationCode}}
            </div>
            <div class="box driverLegalIdentification">
                <div class="toplabel">{{'ROUTEPAGE.ITEM.EDIT.DRIVERLEGALIDENTIFICATION' | translate}}</div><span
                    class="invisible"
                    *ngIf="!data.driverLegalIdentification">{{'SHARED.EXTERNAL.NODRIVERLEGALIDENTIFICATION' |
                    translate}}</span>
                {{data.driverLegalIdentification}}
            </div>
            <div class="box driverPhone">
                <div class="toplabel">{{'ROUTEPAGE.ITEM.EDIT.DRIVERPHONE' | translate}}</div><span
                    class="invisible" *ngIf="!data.driverPhone">{{'SHARED.EXTERNAL.NODRIVERPHONE' |
                    translate}}</span>
                <a *ngIf="data.driverPhone" href="tel:{{data.driverPhone}}"><i class="fa fa-phone-square"
                        aria-hidden="true"></i>{{data.driverPhone}}</a>
            </div>

            <div class="box plateA">
                <div class="toplabel">{{'ROUTEPAGE.ITEM.EDIT.PLATEA' | translate}}</div><span class="invisible"
                    *ngIf="!data.plateA">{{'SHARED.EXTERNAL.NOPLATEA' | translate}}</span> {{data.plateA}}
            </div>
            <div class="box plateB">
                <div class="toplabel">{{'ROUTEPAGE.ITEM.EDIT.PLATEB' | translate}}</div><span class="invisible"
                    *ngIf="!data.plateB">{{'SHARED.EXTERNAL.NOPLATEB' | translate}}</span> {{data.plateB}}
            </div>
            <div class="box plateC" *ngIf="!data.hidePlateC">
                <div class="toplabel">{{ data.resourcePlateC | translate}}</div><span class="invisible"
                    *ngIf="!data.plateC">{{'SHARED.EXTERNAL.NOPLATEC' | translate}}</span> {{data.plateC}}
            </div>

            <button-link *ngIf="!requereixBooking() && !data.readonlyDataInfo"
                class="link right positionrara important"
                (click)="startEditmode()">{{'SHARED.EXTERNAL.EDIT.BUTTON' | translate}}</button-link>
            <div *ngIf="data.readonlyDataInfo && data.inGate" class="help-readonlydatainfo">
                {{'SHARED.EXTERNAL.EDIT.NOTEDITINGATE' | translate}}
            </div>
        </div>
    </div>
    <div class="canvi-dades"
        *ngIf="algoAFer() && !data.readonly && !data.readonlyDataInfo && !requereixBooking()">
        <div class="zona-edit" *ngIf="editMode">
            <div class="title d-block">{{ 'SHARED.EXTERNAL.EDIT.TITLE' | translateH }}</div>
            <div class="help">
                {{'SHARED.EXTERNAL.EDIT.HELP' | translate}}
            </div>
            <div class="btn-close" (click)="cancel()">
                <i class="fa fa-close"></i>
            </div>
            <div class="data-block"
                *ngIf="data.showAskCarrierName || data.showAskCarrierLegalIdentification || data.showAskCarrierAddress">
                <span class="data-block-title">
                    <i class="fa fa-building" aria-hidden="true"></i>
                    <span class="title">
                        {{ 'SHARED.EXTERNAL.EDIT.CARRIER.TITLE' | translate}}
                    </span>
                </span>
                <input-component *ngIf="data.showAskCarrierName" class="col-x" [(ngModel)]="carrierName"
                    placeholder="{{'ROUTEPAGE.ITEM.EDIT.CARRIERNAME' | translate}}"></input-component>
                <input-component *ngIf="data.showAskCarrierLegalIdentification" class="col-x"
                    [(ngModel)]="carrierLegalIdentification"
                    placeholder="{{'ROUTEPAGE.ITEM.EDIT.CARRIERLEGALIDENTIFICATION' | translate}}"></input-component>
                <input-component *ngIf="data.showAskCarrierAddress" class="col-x" [(ngModel)]="carrierAddress"
                    placeholder="{{'ROUTEPAGE.ITEM.EDIT.CARRIERADDRESS' | translate}}"></input-component>
            </div>

            <div class="data-block">
                <span class="data-block-title">
                    <i class="fa fa-male" aria-hidden="true"></i>
                    <span class="title">
                        {{ 'SHARED.EXTERNAL.EDIT.DRIVER.TITLE' | translate}}
                    </span>
                </span>
                <input-component class="col-x" [(ngModel)]="driverName"
                    placeholder="{{'ROUTEPAGE.ITEM.EDIT.DRIVERNAME' | translate}}"></input-component>
                <input-component class="col-x" [(ngModel)]="transportationRegistrationCode"
                    placeholder="{{'ROUTEPAGE.ITEM.EDIT.TRANSPORTATIONREGISTRATIONCODE' | translate}}"></input-component>
                <input-component class="col-x" [(ngModel)]="driverLegalIdentification"
                    placeholder="{{'ROUTEPAGE.ITEM.EDIT.DRIVERLEGALIDENTIFICATION' | translate}}"></input-component>

                <input-component class="col-x" [(ngModel)]="driverPhone"
                    placeholder="{{'ROUTEPAGE.ITEM.EDIT.DRIVERPHONE' | translate}}"></input-component>
            </div>

            <div class="data-block">
                <span class="data-block-title">
                    <i class="fa fa-truck" aria-hidden="true"></i>
                    <span class="title">
                        {{ 'SHARED.EXTERNAL.EDIT.PLATES.TITLE' | translate}}
                    </span>
                </span>
                <div class="col-x">
                    <input-component class="col-plate" [(ngModel)]="plateA"
                        placeholder="{{'ROUTEPAGE.ITEM.EDIT.PLATEA' | translate}}"></input-component>
                    <input-component class="col-plate" [(ngModel)]="plateB"
                        placeholder="{{'ROUTEPAGE.ITEM.EDIT.PLATEB' | translate}}"></input-component>
                    <input-component *ngIf="!data.hidePlateC" class="col-plate" [(ngModel)]="plateC"
                        placeholder="{{ data.resourcePlateC | translate}}"></input-component>
                </div>
            </div>

            <shared-savebutton class="botodesar" (save)="save($event)">
                {{'SHARED.EXTERNAL.DRIVER.BUTTON.SAVE' | translate}}
            </shared-savebutton>
        </div>

    </div>
</div>    